






























































































































































































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import { IGame, GamePlatform } from '~/store/games/types';
import { IUser } from '~/store/profile/types';
import MediaCarousel from '~/components/Games/MediaCarousel.vue';
import _debounce from 'lodash.debounce';
import GameActionButton from '~/components/Games/GameActionButton.vue';
import GameRequiredItemButton from '~/components/Games/GameRequiredItemButton.vue';
import GameMobilePlaytestButton from '~/components/Games/GameMobilePlaytestButton.vue';
import GamesBrandedModal from '~/components/UIComponents/GamesBrandedModal.vue';
import GamesBrandedModalFull from '~/components/UIComponents/GamesBrandedModalFull.vue';
import { CheckForRequiredItems, GameActionButtonHost } from '~/mixins';
import { kebabCase } from 'lodash';
import { TextOutput } from '~/mixins';

@Component({
  components: {
    GameActionButton,
    GameRequiredItemButton,
    GameMobilePlaytestButton,
    MediaCarousel,
    GamesBrandedModalFull,
    GamesBrandedModal,
  },
})
export default class GameInfo extends Mixins(
  CheckForRequiredItems,
  GameActionButtonHost,
  TextOutput,
) {
  @State('discordLink') readonly discordLink!: string;
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @Prop(Object) readonly game!: IGame;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  windowWidth = 0;
  debouncedSetWindowWidth = _debounce(this.setWindowWidth, 500);

  isCheckingRequiredItems: boolean = true;
  requireItemButton: boolean = true;

  iosReg = /i(Phone|Pad|Pod)/gi;
  androidReg = /Android/gi;
  userIsIOS: boolean = this.iosReg.test((navigator as any).userAgent);
  userIsAndroid: boolean = this.androidReg.test((navigator as any).userAgent);
  userIsMobile: boolean = this.userIsIOS || this.userIsAndroid;
  showDesktopGameAvailabilityModal = false;
  showAlternateDesktopPlatforms = false;
  isWindows: boolean = navigator.userAgent.includes('Win');
  isMac: boolean = navigator.userAgent.includes('Mac');
  isDesktopMac: boolean = this.isMac && !this.userIsIOS;

  get isGameReleasedOnWindows() {
    return (
      this.game.platform.includes(GamePlatform.Win) && this.game.isWinReleased
    );
  }

  get isGameReleasedOnMac() {
    return (
      this.game.platform.includes(GamePlatform.Mac) && this.game.isMacReleased
    );
  }

  get isGameReleasedOnAndroid() {
    return (
      this.game.platform.includes(GamePlatform.Android) &&
      this.game.hasApkFile &&
      this.game.apkLink
    );
  }

  get isGameReleasedOnIos() {
    return (
      this.game.platform.includes(GamePlatform.iOS) &&
      this.game.hasIOSDownload &&
      this.game.iOSDownloadLink
    );
  }

  get directUserToDifferentDesktopPlatform() {
    if (
      this.game?.platform &&
      !this.userIsMobile &&
      ((this.isWindows &&
        !this.game.platform.includes(GamePlatform.Win) &&
        this.isGameReleasedOnMac) ||
        (this.isDesktopMac &&
          !this.game.platform.includes(GamePlatform.Mac) &&
          this.isGameReleasedOnWindows))
    ) {
      return true;
    }

    return false;
  }

  get isGameOnlyReleasedOnDesktop() {
    if (
      !this.game.isReleased ||
      this.game.hasApkFile ||
      this.game.hasIOSDownload ||
      (this.game.platform.includes(GamePlatform.Browser) &&
        this.game.isReleased &&
        this.game.playLink)
    ) {
      return false;
    } else if (
      ((this.game.platform.includes(GamePlatform.Win) &&
        this.game.isWinReleased) ||
        (this.game.platform.includes(GamePlatform.Mac) &&
          this.game.isMacReleased)) &&
      this.game.isReleased
    ) {
      return true;
    }

    return false;
  }

  get releasedPlatforms() {
    let platforms = '';

    // We only want to display the names of platforms where the game is currently released and available
    if (this.game.isReleased) {
      if (this.isGameReleasedOnMac) {
        platforms = 'Mac';
      }

      if (this.isGameReleasedOnWindows) {
        platforms = platforms ? platforms + ' or PC' : 'PC';
      }

      if (this.isGameReleasedOnAndroid) {
        platforms = platforms ? platforms + ' or Android' : 'Android';
      }

      if (this.isGameReleasedOnIos) {
        platforms = platforms ? platforms + ' or iOS' : 'iOS';
      }
    }

    return platforms;
  }

  created() {
    this.gameActionButtonHostCreated();

    this.$on(this.launcherMessageProcessedEventName, () => {
      const thisGameInstallationStatus = this.gamesInstallStatuses[
        this.game.codeName
      ];
      if (thisGameInstallationStatus) {
        this.game.isInstalled = thisGameInstallationStatus.isInstalled;
        this.game.installedVersion = thisGameInstallationStatus.version;
      }
    });
  }

  mounted() {
    window.addEventListener('resize', this.setWindowWidth);
    if (this.currentUser.loggedIn) {
      this.$store.subscribe(({ type }) => {
        if (type === 'inventory/updateUserItems') {
          this.setRequiredGameItemStatus();
        }
      });
    } else {
      this.setRequiredGameItemStatus();
    }
  }

  destroyed() {
    window.removeEventListener('resize', this.setWindowWidth);
    this.gameActionButtonHostDestroyed({ disableAutoReconnect: true });
  }

  get fetchingReqItem() {
    return this.isCheckingRequiredItems;
  }

  get requireItemButtonStatus() {
    return this.requireItemButton;
  }

  get usePlayButtonRedirect() {
    return (
      this.game?.usePlayButtonRedirect && this.game?.playButtonRedirectLink
    );
  }

  setRequiredGameItemStatus() {
    this.requireItemButton = this.getRequiredGameItemStatus(this.game);
    this.isCheckingRequiredItems = false;
  }

  setWindowWidth(event: any) {
    this.windowWidth = event.target.innerWidth;
  }

  getDownloadableStatus(game: IGame) {
    if (
      game.downloadLink &&
      game.activeStartTimestamp &&
      game.activeEndTimestamp
    ) {
      const now = Date.now();
      const active =
        game.activeStartTimestamp < now && game.activeEndTimestamp > now;
      return active;
    }
    return false;
  }

  handlePlay() {
    if (process.env.displayGameInIframe) {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
      } else if ((document.body as any).webkitRequestFullscreen) {
        (document.body as any).webkitRequestFullscreen();
      }
    }

    this.$router.push(`/games/${this.game.route}/play`);
  }

  apkDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackApkDownloadEvent({
      game: gameName,
    });
  }

  iosDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackIosDownloadEvent({
      game: gameName,
    });
  }

  onTrackOffsiteNavigation(url?: string) {
    if (!url) {
      return;
    }

    this.$ua.trackNavigationEvent({
      from: window?.location?.href,
      to: url,
    });
  }

  kebabText(text: string) {
    return kebabCase(text);
  }
}
